import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBulkEmailInitialState } from "./bulkEmailModel";
import {
  findContactsByState,
  sendBulkEmail,
} from "./services/bulkEmail.services";

const initialState: IBulkEmailInitialState = {
  loading: false,
  sending: false,
  error: "",
  ContactList: [],
};

const bulkEmailSlice = createSlice({
  name: "bulkEmail",
  initialState,
  reducers: {
    clearBulkEmailState: (state) => {
      state.ContactList = [];
      state.error = "";
      state.loading = false;
      state.sending = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findContactsByState.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.ContactList = [];
    });
    builder.addCase(
      findContactsByState.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.ContactList = action.payload || [];
      },
    );
    builder.addCase(findContactsByState.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContactList = [];
    });
    builder.addCase(sendBulkEmail.pending, (state) => {
      state.sending = true;
      state.error = "";
    });
    builder.addCase(sendBulkEmail.fulfilled, (state) => {
      state.sending = false;
    });
    builder.addCase(sendBulkEmail.rejected, (state, action) => {
      state.sending = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBulkEmailState } = bulkEmailSlice.actions;
export default bulkEmailSlice.reducer;
